import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate, Navigate,NavLink, useSearchParams } from "react-router-dom";
import { useGoogleOneTapLogin } from '@react-oauth/google';

import * as AuthConstants from "../../store/constants/auth.constants";
import AuthLayout from "../../components/layouts/AuthLayout";
import ActionCreator from "../../utils/helpers/actionCreator";
import GoogleLoginButton from "../../components/form/GoogleLoginButton";
import TokenHelper from "../../utils/helpers/tokenHelper";
import cacheHelper from "../../utils/helpers/cacheHelper";
// import AuthService from "../../utils/services/auth.service";
import { setLoggedInUser } from "../../store/actions/auth.action";
import { AppConfigs, Loading, UserType, MenuType, SubMenuType } from "../../utils/helpers/constants";
import ProfileService from "../../utils/services/profile.service";


const RegisterNewOrganization = () => {
	const dispatch = useDispatch(), navigate = useNavigate(), isLoggedIn = TokenHelper.checkIfLoggedIn();
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token');
	// const [email, setEmail] = useState({ value: "", errorState: false });
	// const [loading, setLoadingStatus] = useState(false);
	const [loadingSocials, setLoadingSocialsStatus] = useState(false);
	// const ifValidated = !email.value || !password || email.errorState;

	useGoogleOneTapLogin({
		onSuccess: response => handleSocialLogin({
			token: response.credential,
			platform: 'GOOGLE_TAP'
		}).catch(err => console.trace(err)),
		onError: () => toast.error(`Error, cannot validate user via social authentication`),
		cancel_on_tap_outside: false
	});


	if (token) cacheHelper.set(AppConfigs.ACCOUNT_VERIFICATION_KEY, token);
	if (isLoggedIn) return <Navigate to={{ pathname: "/" }} />;


	// const handleFieldValidation = (data) => {
	// 	const validatedEmail = emailValidator(data);
	// 	setEmail(prev => ({ ...prev, value: validatedEmail.validateEmail }));
	// 	validatedEmail.validState === InputValidator.VALID ? setEmail(prev => ({ ...prev, errorState: false })) : setEmail(prev => ({ ...prev, errorState: true }));
	// }

	const handleSocialLogin = async (data) => {
		setLoadingSocialsStatus(true);
		let payload = { token: data.token, platform: data.platform };
		const { data: responseData } = await ProfileService.socialRegister(payload, UserType.TENANT);
		
		// AuthService.validateOAuth(payload, UserType.TENANT);
		await setLoadingSocialsStatus(false);
		if (responseData.status !== Loading.SUCCESS) toast.error(responseData.message);
		else {
			dispatch(ActionCreator(AuthConstants.LOGIN_SUCCESS, !isLoggedIn));
			await dispatch(setLoggedInUser(responseData.data.access));
			navigate(`/auth/${SubMenuType.REGISTERSOCIALORGANISATION}`);
		}
	};

	// const handleLogin = async () => {
	// 	setLoadingStatus(true);
	// 	const { data: responseData } = await AuthService.login({ email: email.value.toLowerCase(), password }, UserType.TENANT);
	// 	await setLoadingStatus(false);
	// 	if (responseData.status !== Loading.SUCCESS) toast.error(responseData.message)
	// 	else {
	// 		dispatch(ActionCreator(AuthConstants.LOGIN_SUCCESS, !isLoggedIn));
	// 		await dispatch(setLoggedInUser(responseData.data.access));
	// 		navigate('/');
	// 	}
	// }


	return (
		<AuthLayout>
			<div className="card">
				<div className="row row-sm">
					<div className="col-lg-2 d-none d-lg-block text-center bg-primary bg-custom" />
					<div className="col-lg-10  col-xs-12 col-sm-12 login_form ">
						<div className="container-fluid">
							<div className="row row-sm">
								<div className="card-body mt-2 mb-2">
									<div>
										<h5 className="text-start mb-2">Create an Account</h5>
										{/* <p className="mb-4 text-muted tx-13 ms-0 text-start">
											Create a truQ Administrator for Backoffice
										</p> */}
									</div>
									<form className="mt-3">
										
										<button className="btn ripple btn-main-primary btn-block mt-5"
											type="button"
											onClick={() => navigate(`/${MenuType.AUTH}/${SubMenuType.REGISTER}`)}>
											Sign up with email
										</button>

										<GoogleLoginButton text={"Sign up with Google"} getResponseData={handleSocialLogin} loadingSocials={loadingSocials} />

									</form>
									{/* <div className="ms-0 mt-3">
										<div className="mb-5 text-end">
											<NavLink to={`/${MenuType.AUTH}/${SubMenuType.FORGOT_PASSWORD}`}>Forgot password?</NavLink>
											<div className="mb-1 mt-4 text-center">Don't have an account?
												<NavLink to={`/${MenuType.AUTH}/${SubMenuType.REGISTER}`}> Sign Up</NavLink>
											</div>
											<div className="text-center">Request Access? <a href="mailto:support@mytruq.com">Send email to
												support</a></div>
										</div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-2 text-center">Already have an account?<NavLink to={`/${MenuType.AUTH}/${SubMenuType.LOGIN}`}> Sign In</NavLink></div>
		</AuthLayout>
	);
}

export default RegisterNewOrganization;
